import { Flex } from '@chakra-ui/react';
import React from 'react';

import * as cookies from 'lib/cookies';
import { Button } from 'toolkit/chakra/button';
import { useColorMode } from 'toolkit/chakra/color-mode';
import { Link } from 'toolkit/chakra/link';
import IconSvg from 'ui/shared/IconSvg';

const actionStyles = {
  alignItems: 'center',
  color: 'text.secondary',
  display: 'flex',
  fontSize: 'xs',
  fontWeight: 500,
  gap: 1.5,
  lineHeight: 1,
  minH: 6,
  paddingInline: 1,
  _hover: {
    color: 'text.primary',
  },
} as const;

const TopBarActions = () => {
  const { colorMode, setColorMode } = useColorMode();

  const handleThemeToggle = React.useCallback(() => {
    const nextColorMode = colorMode === 'dark' ? 'light' : 'dark';

    setColorMode(nextColorMode);
    cookies.set(cookies.NAMES.COLOR_MODE, nextColorMode);
    cookies.set(cookies.NAMES.COLOR_THEME, nextColorMode);
  }, [ colorMode, setColorMode ]);

  return (
    <Flex alignItems="center" gap={{ base: 2, sm: 4 }}>
      <Button
        variant="plain"
        size="xs"
        aria-label="Switch theme"
        onClick={ handleThemeToggle }
        { ...actionStyles }
      >
        <IconSvg name="sun" boxSize={ 3.5 } display={{ _light: 'none', _dark: 'block' }}/>
        <IconSvg name="moon" boxSize={ 3.5 } display={{ _light: 'block', _dark: 'none' }}/>
        Theme
      </Button>
      <Link
        href="https://docs.dotone.online/developers/api-reference"
        external
        noIcon
        aria-label="API Docs"
        { ...actionStyles }
      >
        <IconSvg name="docs" boxSize={ 3.5 }/>
        API Docs
      </Link>
    </Flex>
  );
};

export default React.memo(TopBarActions);
